export const en = {
  common: {
    language: "Language",
    spanish: "Español",
    english: "English",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    delete: "Delete",
    save: "Save",
    saving: "Saving...",
    actions: "Actions",
  },
  auth: {
    title: "Magma NFC System",
    subtitle: "Data capture system for carbon fiber specialists",
    email: "Email",
    password: "Password",
    fullName: "Full Name",
    operatorArea: "Work Area",
    selectArea: "Select your area",
    areas: {
      corte_plotter: "Cutting / Plotter",
      laminador: "Laminator",
      taller: "Workshop",
      generico: "Generic / Temporary",
    },
    signIn: "Sign In",
    signUp: "Sign Up",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    signInHere: "Sign in here",
    signUpHere: "Sign up here",
    emailRequired: "Email is required",
    emailInvalid: "Invalid email",
    passwordRequired: "Password is required",
    passwordMin: "Password must be at least 6 characters",
    nameRequired: "Name is required",
    areaRequired: "You must select a work area",
  },
  filters: {
    selectArea: "Filter by area",
    allAreas: "All areas",
  },
  operatorAssignment: {
    title: "Operator Assignment",
    subtitle: "Real-time operator distribution and status by area",
    totalOperators: "Total Operators",
    activeOperators: "Active Operators",
    inactiveOperators: "Inactive Operators",
    registered: "Registered",
    working: "Working",
    available: "Available",
    distributionByArea: "Distribution by Area",
    areaStatistics: "Area Statistics",
    operatorList: "Operator List",
    operators: "operators",
    active: "active",
    inactive: "inactive",
    order: "Order",
    noOperators: "No registered operators",
    noShift: "No shift",
    shifts: {
      morning: "Morning",
      afternoon: "Afternoon",
      night: "Night",
    },
  },
  nav: {
    dashboard: "Dashboard",
    workOrders: "Work Orders",
    nfcCaptures: "NFC Captures",
    analytics: "Analytics",
    integrations: "Integrations",
    settings: "Settings",
  },
  dashboard: {
    welcome: "Welcome to Magma NFC System",
    subtitle: "Real-time production data from carbon fiber manufacturing",
    nfcToday: "NFC Captures Today",
    activeDevices: "Active Devices",
    operators: "Operators",
    successRate: "Success Rate",
    dailyCaptures: "Daily NFC Captures",
    productionFlow: "Production Data Flow",
    fromYesterday: "from yesterday",
    allOnline: "All online",
    shiftsActive: "shifts active",
    thisWeek: "this week",
    activeOrders: "Active Orders",
    inProgressProcesses: "In Progress Processes",
    activeOperators: "Working Operators",
    completionRate: "Completion Rate",
    inProgress: "In progress",
    noActive: "No activity",
    active: "Active",
    workingNow: "Working now",
    today: "Today",
    refresh: "Refresh",
    alerts: "Alerts and Issues",
    noAlerts: "No active alerts",
    realtimeEvolution: "Real-time Evolution",
    performanceMetrics: "Performance Metrics",
    configure: "Configure",
    dashboardSettings: "Dashboard Settings",
    dashboardSettingsDesc: "Customize your dashboard, choose widgets and save views",
    selectView: "Select View",
    manageViews: "Manage Views",
    setAsDefault: "Set as default",
    selectWidgets: "Select Widgets",
    saveNewView: "Save as New View",
    viewName: "View name",
    saveView: "Save View",
    editMode: "Edit",
    exitEditMode: "Exit",
    editModeDesc: "Edit mode enabled: drag widgets to reorganize them",
  },
  nfcCaptures: {
    title: "NFC Captures",
    subtitle: "Real-time mobile data collection from production plant",
    newSession: "New Capture Session",
    loading: "Loading captures...",
    noCaptures: "No NFC captures",
    noCapturesDesc: "Start a new capture session to see data here",
    startFirst: "Start First Capture",
    viewDetails: "View Details",
    device: "Device",
    operator: "Operator",
    location: "Location",
    dataPoints: "Data Points",
    unknown: "Unknown",
    status: {
      completed: "Completed",
      processing: "Processing",
      error: "Error",
    },
  },
  nfcTags: {
    title: "NFC Tags Administration",
    subtitle: "Manage physical NFC tag inventory",
    register: "Register Tag",
    registerTag: "Register New NFC Tag",
    editTag: "Edit NFC Tag",
    registerDescription: "Register a new NFC tag in the system",
    editDescription: "Modify tag assignment and status",
    tagUID: "Tag UID",
    tagLabel: "Tag Label/Name",
    workOrder: "Work Order",
    process: "Process",
    location: "Location",
    status: "Status",
    notes: "Notes",
    notesPlaceholder: "Additional information about the tag...",
    selectWorkOrder: "Select...",
    selectProcess: "Select...",
    none: "None",
    statusActive: "Active",
    statusInactive: "Inactive",
    statusDamaged: "Damaged",
    statusLost: "Lost",
    totalTags: "Total",
    activeTags: "Active",
    inactiveTags: "Inactive",
    damagedTags: "Damaged",
    filterByStatus: "Filter by status",
    allStatus: "All",
    assignment: "Assignment",
    lastScan: "Last Scan",
    noTags: "No tags registered",
    noTagsDesc: "Start by registering your first NFC tag",
    created: "Tag registered",
    updated: "Tag updated",
    deleted: "Tag deleted",
    confirmDelete: "Delete this tag?",
    unknown: "Unknown",
    printLabel: "Print Label",
  },
  analytics: {
    title: "Analytics",
    subtitle: "System metrics and reports",
    performanceTrends: "Performance Trends",
    revenueOverview: "Revenue Overview",
  },
  operatorView: {
    title: "Select Work:",
    myTasks: "My Tasks",
    pendingWorks: "Pending Works",
    nfcScan: "Scan NFC",
    waitingTag: "Waiting for Tag",
    scanNow: "Scan Now",
    noAssignedTasks: "You have no assigned tasks",
    noAssignedTasksDesc: "Contact your supervisor to assign you work",
    startProcess: "Start Process",
    processStarted: "Process started",
    nfcNotSupported: "NFC not supported on this device",
    nfcAndroidOnly: "Available only on Android with Chrome",
    approachTag: "Bring your device close to an NFC tag...",
    tagDetected: "Tag detected!",
    writeTag: "Write NFC",
  },
  workOrders: {
    title: "Work Orders",
    subtitle: "Production order management",
    newOrder: "New Order",
    orderNumber: "Order Number",
    productName: "Product",
    customer: "Customer",
    quantity: "Quantity",
    priority: "Priority",
    status: "Status",
    createdAt: "Created",
    startedAt: "Started",
    completedAt: "Completed",
    actions: "Actions",
    viewDetails: "View Details",
    noOrders: "No work orders",
    noOrdersDescription: "Start by creating a new work order",
    createOrder: "Create Order",
    editOrder: "Edit Order",
    orderDetails: "Order Details",
    processes: "Processes",
    addProcess: "Add Process",
    selectProcess: "Select Process",
    selectOperator: "Select Operator",
    startProcess: "Start Process",
    completeProcess: "Complete Process",
    pauseProcess: "Pause Process",
    resumeProcess: "Resume Process",
    addPause: "Add Pause",
    pauseReason: "Pause Reason",
    duration: "Duration",
    notes: "Notes",
    processData: "Process Data",
    operator: "Operator",
  },
  processes: {
    material_arrival: "Material Arrival",
    freezer_storage: "Freezer Storage",
    material_cutting: "Material Cutting",
    mold_selection: "Mold Selection",
    material_layup: "Material Layup",
    vacuum_bagging: "Vacuum Bagging",
    autoclave_curing: "Autoclave Curing",
    demolding: "Demolding",
    quality_inspection: "Quality Inspection",
    cutting_workshop: "Cutting Workshop",
    packaging: "Packaging",
    dispatch: "Dispatch",
  },
  processFields: {
    freezer_number: "Freezer Number",
    temperature: "Temperature",
    cutting_method: "Cutting Method",
    mold_id: "Mold ID",
    mold_type: "Mold Type",
    layers: "Layers",
    material_type: "Material Type",
    vacuum_pressure: "Vacuum Pressure",
    autoclave_number: "Autoclave Number",
    pressure: "Pressure",
    duration: "Duration",
    passed: "Passed",
    defects: "Defects",
    packaging_type: "Packaging Type",
    destination: "Destination",
    tracking_number: "Tracking Number",
  },
  statuses: {
    pending: "Pending",
    in_progress: "In Progress",
    completed: "Completed",
    cancelled: "Cancelled",
    paused: "Paused",
  },
  shifts: {
    morning: "Morning",
    afternoon: "Afternoon",
    night: "Night",
  },
  experienceLevels: {
    junior: "Junior",
    mid: "Mid-Level",
    senior: "Senior",
    expert: "Expert",
  },
  integrations: {
    title: "Integrations",
    subtitle: "Connect Magma NFC system with CRM and ERP platforms",
    connect: "Connect",
    available: "Available",
    comingSoon: "Coming Soon",
    salesforce: {
      name: "Salesforce CRM",
      description: "Sync customer data and sales pipelines",
    },
    sap: {
      name: "SAP ERP",
      description: "Connect with enterprise resource planning",
    },
    hubspot: {
      name: "HubSpot",
      description: "Marketing automation and CRM",
    },
    netsuite: {
      name: "Oracle NetSuite",
      description: "Cloud-based business management suite",
    },
    dynamics: {
      name: "Microsoft Dynamics",
      description: "Comprehensive business applications",
    },
    zoho: {
      name: "Zoho CRM",
      description: "Sales and marketing platform",
    },
  },
  settings: {
    title: "Settings",
    subtitle: "Configure your Magma NFC system preferences",
    general: "General",
    preferences: "Preferences",
    workspaceName: "Workspace Name",
    emailNotifications: "Email Notifications",
    realtimeUpdates: "Real-time Updates",
    realtimeUpdatesDesc: "Automatically refresh data from connected sources",
    emailAlerts: "Email Alerts",
    emailAlertsDesc: "Receive notifications about system events",
    dataExport: "Data Export",
    dataExportDesc: "Allow automated data exports",
    customKPIs: "Custom KPIs",
    addNewKPI: "Add New KPI",
    metric: "Metric",
    selectMetric: "Select metric",
    condition: "Condition",
    greaterThan: "Greater than",
    lessThan: "Less than",
    equalTo: "Equal to",
    threshold: "Threshold",
    notifications: "Notifications",
    add: "Add",
    noKPIsConfigured: "No KPIs configured yet",
    kpiAdded: "KPI added successfully",
    kpiUpdated: "KPI updated successfully",
    kpiDeleted: "KPI deleted successfully",
    errorLoadingKPIs: "Error loading KPIs",
    errorAddingKPI: "Error adding KPI",
    errorUpdatingKPI: "Error updating KPI",
    errorDeletingKPI: "Error deleting KPI",
    success: "Success",
    error: "Error",
    cancel: "Cancel",
    saveChanges: "Save Changes",
  },
  sidebar: {
    nfcSystem: "NFC Data Capture System",
    dashboard: "Dashboard",
    operatorView: "Operator View",
    operatorAssignment: "Operator Assignment",
    registerUser: "Register User",
    userManagement: "User Management",
    qrTraceability: "QR Traceability",
    nfcCaptures: "NFC Captures",
    nfcTagsAdmin: "NFC Tags Admin",
    analytics: "Analytics",
    integrations: "Integrations",
    settings: "Settings",
    workOrders: "Work Orders",
    nfcReady: "NFC Ready",
    mobileEnabled: "Mobile capture enabled",
  },
  userManagement: {
    title: "User Management",
    subtitle: "Manage user roles and permissions",
    totalUsers: "Total Users",
    supervisors: "Supervisors",
    operators: "Operators",
    userList: "User List",
    name: "Name",
    employeeId: "Employee ID",
    area: "Area",
    shift: "Shift",
    role: "Role",
    actions: "Actions",
    noUsers: "No users registered",
    editRole: "Edit User Role",
    editRoleDescription: "Change user role and permissions",
    newRole: "New Role",
    roleOperator: "Operator",
    roleSupervisor: "Supervisor",
    roleAdmin: "Administrator",
    save: "Save",
    saving: "Saving...",
    roleUpdated: "Role updated successfully",
    roleUpdateError: "Error updating role",
    noArea: "No area",
    noShift: "No shift",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    userActivated: "User activated successfully",
    userDeactivated: "User deactivated successfully",
    statusUpdateError: "Error updating status",
    auditHistory: "Audit History",
    date: "Date",
    changedBy: "Changed by",
    affectedUser: "Affected User",
    action: "Action",
    changes: "Changes",
    created: "Created",
    updated: "Updated",
    deleted: "Deleted",
    noAuditLogs: "No audit logs",
  },
  header: {
    profile: "Profile",
    logout: "Logout",
  },
  billing: {
    title: "Billing",
    dashboard: "Billing Dashboard",
    invoices: "Invoices",
    newInvoice: "New Invoice",
    editInvoice: "Edit Invoice",
    customers: "Billing Customers",
    suppliers: "Suppliers",
    articles: "Articles",
    deliveryNotes: "Delivery Notes",
    supplierOrders: "Supplier Orders",
    settings: "Billing Settings",
    status: {
      draft: "Draft",
      issued: "Issued",
      sent: "Sent",
      paid: "Paid",
      partial: "Partial",
      cancelled: "Cancelled",
      overdue: "Overdue",
      rectified: "Rectified",
    },
    fields: {
      invoiceNumber: "Invoice Number",
      issueDate: "Issue Date",
      dueDate: "Due Date",
      subtotal: "Subtotal",
      tax: "Tax",
      total: "Total",
      customer: "Customer",
      notes: "Notes",
      paymentMethod: "Payment Method",
      reference: "Reference",
    },
    actions: {
      create: "Create Invoice",
      send: "Send",
      download: "Download PDF",
      duplicate: "Duplicate",
      markPaid: "Mark as Paid",
      cancel: "Cancel",
    },
    noInvoices: "No invoices",
    noInvoicesDesc: "Start by creating your first invoice",
  },
  timeTracking: {
    title: "Time Tracking",
    subtitle: "Mandatory time recording (RDL 8/2019)",
    admin: "Time Tracking (Admin)",
    state: "Status",
    now: "Now",
    clockIn: "Clock In",
    clockOut: "Clock Out",
    breakStart: "Start Break",
    breakEnd: "End Break",
    currentState: {
      working: "Working",
      onBreak: "On Break",
      off: "Off",
      notStarted: "Not Started",
    },
    buttons: {
      clockIn: "Clock In",
      clockOut: "Clock Out",
      startBreak: "Start Break",
      resumeWork: "Resume After Break",
    },
    nfc: {
      personalNfc: "Quick check-in via personal NFC",
      usbReaderReady: "USB Reader Ready",
      scanMobile: "Scan with Mobile NFC",
      connectReader: "Connect a USB NFC reader or use your mobile",
      chipNotRegistered: "Chip not registered. Ask an admin to assign it in NFC Tags.",
      chipNotAssigned: "Chip not assigned to any user.",
    },
    messages: {
      eventRegistered: "registered",
      errorRegistering: "Error registering time",
      errorNfc: "NFC check-in error",
    },
    hoursToday: "Hours Today",
    hoursWeek: "Hours This Week",
    summary: "Summary",
    history: "History",
    events: "Events",
    noEvents: "No events today",
    todayEvents: "Today's Events",
    selectEmployee: "Select Employee",
    allEmployees: "All Employees",
    exportReport: "Export Report",
    dateRange: "Date Range",
    overtime: "Overtime",
    regularHours: "Regular Hours",
  },
  accounting: {
    title: "Accounting",
    chartOfAccounts: "Chart of Accounts",
    journalEntries: "Journal Entries",
    generalLedger: "General Ledger",
    trialBalance: "Trial Balance",
    status: {
      draft: "Draft",
      posted: "Posted",
      reversed: "Reversed",
    },
    fields: {
      entryNumber: "Entry Number",
      entryDate: "Date",
      description: "Description",
      debit: "Debit",
      credit: "Credit",
      account: "Account",
      balance: "Balance",
      period: "Period",
    },
    actions: {
      newEntry: "New Entry",
      post: "Post",
      reverse: "Reverse",
      export: "Export",
    },
    noEntries: "No entries",
    noEntriesDesc: "Start by creating a new journal entry",
  },
  payroll: {
    title: "Payroll",
    admin: "Payroll Management",
    myPayslips: "My Payslips",
    upload: "Upload Payslip",
    download: "Download",
    sign: "Sign",
    period: "Period",
    employee: "Employee",
    status: {
      pending: "Pending",
      signed: "Signed",
      rejected: "Rejected",
      viewed: "Viewed",
    },
    noPayslips: "No payslips",
    noPayslipsDesc: "Payslips will appear here when available",
    signatureRequired: "Signature Required",
    alreadySigned: "Already Signed",
    fields: {
      grossSalary: "Gross Salary",
      netSalary: "Net Salary",
      deductions: "Deductions",
      uploadDate: "Upload Date",
      signDate: "Sign Date",
    },
  },
  ai: {
    assistant: "AI Assistant",
    title: "Athenea Assistant",
    placeholder: "Type your question...",
    thinking: "Thinking...",
    typing: "Typing...",
    clearChat: "Clear Chat",
    newChat: "New Conversation",
    suggestions: "Suggestions",
    online: "Online",
    offline: "Offline",
    greeting: "Hello! I'm your AI assistant for Athenea. I can help you with:",
    capabilities: {
      analyzeProduction: "Analyze production data",
      answerQuestions: "Answer questions about the system",
      suggestOptimizations: "Suggest optimizations",
      searchData: "Search information",
    },
    error: "Sorry, there was an error. Please try again.",
    disabled: "AI is disabled. Contact your administrator.",
    rateLimit: "Too many requests. Please wait a moment.",
  },
  sidebarSections: {
    dashboard: "Dashboard",
    operations: "Operations",
    production: "Production",
    design: "Design & CNC",
    inventory: "Inventory",
    commercial: "Commercial Management",
    quality: "Quality & Traceability",
    billing: "Billing",
    purchases: "Purchases",
    legal: "Legal & Compliance",
    system: "System",
    admin: "Administration",
  },
  sidebarItems: {
    executiveDashboard: "Executive Dashboard",
    myWork: "My Work",
    personal: "Personnel",
    shiftManagement: "Shift Management",
    timeTracking: "Time Tracking",
    timeTrackingAdmin: "Time Tracking (Admin)",
    myPayslips: "My Payslips",
    tasks: "Tasks",
    processes: "Processes",
    products: "Products",
    molds: "Molds",
    machines: "Machines",
    autoclaveCycles: "Autoclave Cycles",
    recipes: "Recipes",
    plybooks: "Plybooks",
    schedule: "Scheduling",
    flowSimulation: "Flow Simulation",
    workTypes: "Work Types",
    designProjects: "Design Projects",
    cncLibrary: "CNC Library",
    masters: "Masters",
    generalInventory: "General Inventory",
    plotterCuts: "Plotter Cuts",
    freezerControl: "Freezer Control",
    workshopCutting: "Workshop Cutting",
    tools: "Tools",
    labels: "Labels",
    customers: "Customers",
    projects: "Projects",
    budgets: "Budgets",
    purchaseOrders: "Purchase Orders (PO)",
    quotations: "Quotations",
    events: "Events",
    news: "News",
    qualityControl: "Quality Control",
    traceability: "Traceability",
    billingPanel: "Billing Panel",
    invoices: "Invoices",
    deliveryNotes: "Delivery Notes",
    articles: "Articles",
    supplierOrders: "Supplier Orders",
    suppliers: "Suppliers",
    billingCustomers: "Billing Customers",
    chartOfAccounts: "Chart of Accounts",
    journalEntries: "Journal Entries",
    generalLedger: "General Ledger",
    billingSettings: "Billing Settings",
    trialBalance: "Trial Balance",
    expenses: "Expenses",
    legalDocuments: "Legal Documents",
    compliance: "INDRA Compliance",
    requirements: "Requirements Management",
    riskPrevention: "Risk Prevention",
    reports: "Reports",
    traceabilityHistory: "Traceability",
    supportTickets: "Support Tickets",
    nfcTagsAdmin: "NFC Tags Admin",
    payrollAdmin: "Payroll Management",
  },
  quotations: {
    title: "Quotation System",
    subtitle: "Perseo - Professional quotations for Magma Composites",
    fullscreen: "Fullscreen",
    newWindow: "New Window",
    back: "Back",
    recentFiles: "Recent Files",
    noFiles: "Generated files will appear here",
  },
  freezer: {
    title: "Freezer Control",
    materialsOutside: "Materials Outside",
    temperatures: "Temperatures",
    totalOutside: "Total Outside",
    critical: "Critical",
    warning: "Warning",
    ok: "OK",
    returnToFreezer: "Return to Freezer",
    timeRemaining: "Time Remaining",
    expired: "Expired",
    registerTemp: "Register Temperature",
    freezerStatus: "Freezer Status",
    tempHistory: "Temperature History",
    outOfRange: "Out of Range",
    shiftStart: "Shift Start",
    shiftEnd: "Shift End",
  },
};
